module.exports = __webpack_public_path__ + "static/img/ludwig.b6e6ca4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ludwig.jpg
// module id = jytC
// module chunks = 1